import React, { useEffect, useState, useRef } from "react";
import "./style.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Container, Row, Col } from "react-bootstrap";
import { meta } from "../../content_option";
import { galleryData } from "./data";
import Footer from "../../components/footer";
import ReactMasonry from "../../components/masnory";
import { useDispatch, useSelector } from "react-redux";
import { allDocument } from "../../features/imageUpload/imageUpload.action";
import { Box, CircularProgress } from "@material-ui/core";
import footvideo from "../../assets/videos/Website Full 1920 X 1080.mp4";
// import faq from "../../assets/videos/videoplayback.mp4";
import faq from "../../assets/videos/Darsh-new.mp4";
import GridComponent from "../../components/grid/index";
// import vector from "../../assets/videos/vectorlogo.png"
// import vector from "../../assets/videos/Mountain4.jpg"
import vector from "../../assets/videos/Mountain4_transparent.png";
import AOS from "aos";
export const Gallery = () => {
  const dispatch = useDispatch();
  const { allDoc, allDocLoading, allDocLoadingSucess } = useSelector(
    (state) => state.imageUpload
  );

  const contentRef = useRef(null); // Create a ref for the target section

  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  useEffect(() => {
    dispatch(allDocument());
  }, [dispatch]);

  const scrollToContent = () => {
    contentRef.current?.scrollIntoView({ behavior: "smooth" }); // Smooth scroll to the target section
  };

  return (
    <HelmetProvider>
      <div className="gallery-header pt-5">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Moving Arts | {meta.title}</title>
          <meta name="description" content={meta.description} />
        </Helmet>

        <div style={{ pointerEvents: "none", position: "relative" }}>
          <video
            src={footvideo}
            autoPlay
            loop
            muted
            playsInline
            controlsList="nodownload nofullscreen noremoteplayback"
            disablePictureInPicture
            style={{
              // height: "55vh",
              width: "100%",
              // position: "absolute",
              objectFit: "cover",
              zIndex: "-1",
              marginTop: "-90px",
              pointerEvents: "none", // Extra protection against interaction
              userSelect: "none", // Prevent text selection
              WebkitTouchCallout: "none",
            }}
          ></video>
        </div>

        <div className="vector-container container">
          {/* <h1 className="heading">Made in Heaven Stories</h1> */}
          <img
            src={vector}
            className="vector-image"
            alt="Vector Logo"
            onClick={scrollToContent} // Add click handler to the image
            style={{ cursor: "pointer" }} // Make it clear that the image is clickable
          />
          {/* <h1 className="heading2">Together is a beautiful place to be</h1> */}
          <h1 className="heading2">Made in Heaven Stories</h1>
        </div>

        {/* Add the ref to the target section */}
        <div ref={contentRef}>
          {allDocLoading && (
            <Box style={{ display: "flex", justifyContent: "center" }}>
              <CircularProgress />
            </Box>
          )}

          {allDocLoadingSucess && <GridComponent data={allDoc && allDoc} />}
        </div>
      </div>

      <div style={{ backgroundColor: "black" }}>
        <video
          src={faq}
          autoPlay
          loop
          muted
          className="vid"
          playsInline
          controlsList="nodownload nofullscreen noremoteplayback"
          disablePictureInPicture
          style={{
            padding: "20px",
            width: "100%",
            borderRadius: "50px",
            objectFit: "cover",
          }}
        ></video>
      </div>

      {/* <Footer /> */}
    </HelmetProvider>
  );
};
